import moment from 'moment';
import { Config } from '../Config';

export const API_FETCH = (endpoint) => {
  const _baseURL = Config.API_BASE_URL();
  return _baseURL + endpoint;
};
export const API_ADMIN_FETCH = (endpoint) => {
  const _baseURL = Config.API_ADMIN_BASE_URL();
  return _baseURL + endpoint;
};

export const convertArraytoCSV = (v, rev) => {
  // note: this is the util function to convert array ==> csv and viceversa
  return rev ? v && v.split(',') : v && v.toString();
};
export const replaceSpaceWithComma = (v, rev) => {
  // note: this is the util function to convert space ==> Comma and viceversa
  return rev ? v && v.replace(/[,]+/g, ' ') : v && v.replace(/[ ]+/g, ',');
};
// export const baseCampDetailsReady = (v) => {};

export const dateRangeSeperator = (v) => {
  if (v && v.length && v !== undefined && !v.includes(undefined)) {
    // console.log("startdate", moment(v[0]._i).utcOffset("-05:30", true));
    return {
      // startdate: `${v[0]._d}`,
      startdate: moment.utc(v[0]._d.toISOString())._i,
      // enddate: `${v[1]._d}`,
      enddate: moment.utc(v[1]._d.toISOString())._i,
    };
  } else {
    return { startdate: null, enddate: null };
  }
};

export const checkObjectKeyValues = (v, enabledEmptyArr) => {
  // note: this function will filter out all type of empty values
  const _obj = {};
  for (const [key, value] of Object.entries(v)) {
    if (value !== undefined && value !== null) {
      if ((typeof value === 'string' || typeof value === 'number') && value) {
        _obj[key] = value;
      }
      // if (typeof value === "object" && Object.keys(value).length !== 0) { //not date check
      if (
        (typeof value === 'object' && Object.keys(value).length !== 0) ||
        !isNaN(Date.parse(value))
      ) {
        // with date type check
        _obj[key] = value;
      }

      // force enable empty array
      if (Object.keys(value).length === 0 && enabledEmptyArr) {
        _obj[key] = value;
      }
    }
  }
  return _obj;
};

export const renameKeyName = (obj, oldName, newName) => {
  const { [newName]: value, ...remainingObj } = obj;
  return {
    ...remainingObj,
    [newName]: value,
  };
};

export const scriptInject = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export const UPIValidator = (_v) => {
  // return /^[\w.-]+@[\w.-]+$/.test(_v);
  return /[a-zA-Z0-9\.\-\_]{2,256}\@[a-zA-Z][a-zA-Z]{2,64}/.test(_v);
};
export const EmailRegxValidator = (_v) => {
  // return /^[\w.-]+@[\w.-]+$/.test(_v);
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    _v,
  );
};
export const phoneValidator = (_v, country) => {
  const patterns = {
    IN: /^[5-9]\d{9}$/,
  };
  return country ? patterns[`${country}`].test(_v) : patterns[`IN`].test(_v);
};

export const URLValidator = (url) => {
  try {
    return toString.call(url) === '[object String]' && !!new URL(url);
  } catch (_) {
    return false;
  }
};

export const numberToShortFormat = (_v) => {
  // Nine Zeroes for Billions
  if (isNaN(_v)) {
    return 'Nil';
  } else {
    return Math.abs(Number(_v)) >= 1.0e9 ?
      (Math.abs(Number(_v)) / 1.0e9).toFixed(2) + ' B' : // Six Zeroes for Millions
      Math.abs(Number(_v)) >= 1.0e6 ?
        (Math.abs(Number(_v)) / 1.0e6).toFixed(2) + ' M' : // Three Zeroes for Thousands
        Math.abs(Number(_v)) >= 1.0e3 ?
          (Math.abs(Number(_v)) / 1.0e3).toFixed(1) + ' K' :
          Math.abs(Number(_v));
  }
};

export const validatePlatformShareURL = (_v, platform) => {
  const _pat = {
    y: /^(?:https?:)?(?:\/\/)?(?:youtu\.be\/|(?:www\.|m\.)?youtube\.com\/(?:watch|v|embed)(?:\.php)?(?:\?.*v=|\/))([a-zA-Z0-9\_-]{7,15})(?:[\?&][a-zA-Z0-9\_-]+=[a-zA-Z0-9\_-]+)*(?:[&\/\#].*)?$/,
    i: /(https?:\/\/(?:www\.)?instagram\.com\/(p|tv)\/([^/?#&]+)).*/,
    t: /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/,
  };
  if (platform === 'youtube') {
    return _pat.y.test(_v);
  } else if (platform === 'instagram') {
    return _pat.i.test(_v);
  } else if (platform === 'twitter') {
    return _pat.t.test(_v);
  } else {
    return URLValidator(_v);
  }
};

export const dateDiffFinder = (startDate, endDate) => {
  const _start = moment(startDate);
  const _end = moment(endDate);
  return _end.diff(_start, 'days');
};
export const caculateTAX = (_v, _roi) => {
  console.log('roi', _roi);
  return (_v * _roi) / 100;
};
export const caculateTDS = (_v, _roi) => {
  return (_v * _roi) / 100;
};

export const validatorGSTIN = (_v) => {
  const _p =
    /^[0-9]{2}[A-Za-z]{3}[CPHFATBLJGcphfatblj]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}[0-9A-Za-z]{1}(Z|z)[0-9A-Za-z]{1}$/;
  return _p.test(_v);
};
export const validatorPAN = (_v) => {
  const _p = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return _p.test(_v);
};
export const validatorPINCODE = (_v) => {
  const _p = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;
  return _p.test(_v);
};
